// extracted by mini-css-extract-plugin
export default {"cursor":"CursorGradient_cursor__xItwN"};